import * as Yup from "yup";
import { FormValidation } from "@/src/type/strapi/component/translate";

const phoneRegExp = /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
//const countryCodeRegExp = /^\d+$/;

export const contactUsValidationSchema = (validation: FormValidation | undefined) =>
  Yup.object().shape({
    firstName: Yup.string().required(validation?.firstNameRequired).min(2, validation?.firstNameRequired).max(50, validation?.firstNameTooLong),
    lastName: Yup.string().required(validation?.lastNameRequired).min(2, validation?.lastNameRequired).max(50, validation?.lastNameTooLong),
    email: Yup.string().email(validation?.emailMustBeValid).max(50, validation?.emailTooLong).required(validation?.emailRequired),
    countryCode: Yup.number()
      .min(1, validation?.countryCodeMustBeValid)
      .max(998, validation?.countryCodeMustBeValid)
      .required(validation?.countryCodeRequired)
      .typeError(validation?.countryCodeMustBeValid ?? "Country code must be a number"),
    phoneNumber: Yup.string().matches(phoneRegExp, validation?.phoneNumberMustBeValid).required(validation?.phoneNumberMustBeValid),
    isBroker: Yup.boolean().required(),
    brokerageName: Yup.string().when("isBroker", {
      is: true,
      then: (schema) =>
        schema.required(validation?.brokerageNameRequired).min(2, validation?.brokerageNameRequired).max(255, validation?.brokerageNameTooLong),
    }),
  });

const generalPhoneRegExp =
  /^(?:(?:\(?(?:00|\+)([1-4]\d\d|[1-9]\d*)\)?)[\-\.\ \\\/]?)?((?:\(?\d{1,}\)?[\-\.\ \\\/]?)+)(?:[\-\.\ \\\/]?(?:#|ext\.?|extension|x)[\-\.\ \\\/]?(\d+))?$/i;

const generalContactUsValidationSchema = (validation: FormValidation | undefined) =>
  Yup.object().shape({
    firstName: Yup.string().required(validation?.firstNameRequired).min(2, validation?.firstNameRequired).max(50, validation?.firstNameTooLong),
    lastName: Yup.string().required(validation?.lastNameRequired).min(2, validation?.lastNameRequired).max(50, validation?.lastNameTooLong),
    email: Yup.string().email(validation?.emailMustBeValid).max(50, validation?.emailTooLong).required(validation?.emailRequired),
    phoneNumber: Yup.string().matches(generalPhoneRegExp, validation?.phoneNumberMustBeValid).required(validation?.phoneNumberMustBeValid),
  });

export default {
  contactUsValidationSchema,
  generalContactUsValidationSchema,
};
